import axios from "axios";
import fileDownload from "js-file-download";

export function getFileNameMissingExtension(registrationDocument) {
  const { documentName, documentContentType } = registrationDocument;
  // If document was stored without file name extension, add it from the file type
  if (documentName && !documentName.includes(".") && documentContentType) {
    // Handles cases like image/jpeg, image/png
    if (documentContentType.startsWith("image/")) {
      return documentName + "." + documentContentType.replace("image/", "");
    }
    // Handles cases like application/pdf
    if (documentContentType.startsWith("application/")) {
      return documentName + "." + documentContentType.replace("application/", "");
    }
  }
  return documentName;
}

export const DocumentType = {
  MEDICAL_HISTORY: "MEDICAL_HISTORY",
  STATE_DOCUMENT: "STATE_DOCUMENT",
  BIRTH_CERTIFICATE: "BIRTH_CERTIFICATE",
  IDENTIFICATION: "IDENTIFICATION",
};

export function getRegistrationDocumentsForRegistrationId(registrationId, documentTypes) {
  return axios
    .get(
      process.env.REACT_APP_API +
        "/registration-documents/registration/" +
        registrationId +
        "?" +
        documentTypes.map((docType) => "documentType=" + docType).join("&")
    )
    .then((resp) => resp.data);
}

export function downloadRegistrationDocument(registrationDocument) {
  return axios
    .get(
      process.env.REACT_APP_API +
        "/registration-documents/" +
        registrationDocument.registrationDocumentId +
        "/download",
      {
        responseType: "blob",
      }
    )
    .then((resp) => fileDownload(resp.data, getFileNameMissingExtension(registrationDocument)));
}

export function getRegistrationDocumentContent(registrationDocument) {
  return axios
    .get(process.env.REACT_APP_API + "/registration-documents/" + registrationDocument.registrationDocumentId)
    .then((resp) => resp.data);
}

export function deleteRegistrationDocument(registrationDocument) {
  return axios.delete(
    process.env.REACT_APP_API + "/registration-documents/" + registrationDocument.registrationDocumentId
  );
}

export function uploadRegistrationDocument(registrationId, file, documentType, documentName) {
  const formData = new FormData();
  formData.append("fileToUpload", file);
  formData.append("registrationId", registrationId);
  formData.append("documentType", documentType);
  if (documentName) {
    formData.append("documentName", documentName);
  }
  return axios
    .post(process.env.REACT_APP_API + "/registration-documents", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((resp) => resp.data);
}

export function uploadStateDocument(registrationId, file, uploadDocumentType, documentName) {
  const formData = new FormData();
  formData.append("fileToUpload", file);
  formData.append("registrationId", registrationId);
  formData.append("documentType", uploadDocumentType);
  if (documentName) {
    formData.append("documentName", documentName);
  }
  return axios
    .post(process.env.REACT_APP_API + "/admin/registration-documents", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((resp) => resp.data);
}
